<template>
  <div class="main-content">
    <div class="head-navigate">
      <a-icon
        type="left"
        :style="{ fontSize: '20px', color: '#333' }"
        @click="backPage"
      />
      <span>物业看板</span>
    </div>
    <div>
      <van-tabs v-model="active" color="#1584FF" @click="onClick">
        <van-tab title="财务">
          <div class="menu-content">
            <div class="financial-sum">
              <div>
                <span>财务汇总</span>
                <span @click="allConfirm(0)">{{allAreaSelect}}</span>
                <van-icon
                  name="arrow-down"
                  size="0.4rem"
                  style="margin-right:0.1rem;"
                />
              </div>
              <div class="one-bill">
                <div>
                  <span>未收金额</span>
                  <div>
                    <span>{{allData.thisMonthUnpaidAmount?(allData.thisMonthUnpaidAmount/10000).toFixed(2):0}}</span>
                    <span>(万元)</span>
                  </div>
                  <span>本月</span>
                </div>
                <div class="vertical-line"></div>
                <div>
                  <div>
                    <span>{{allData.pastAllMonthUnpaidAmount?(allData.pastAllMonthUnpaidAmount/10000).toFixed(2):0}}</span>
                    <span>(万元)</span>
                  </div>
                  <span>累计欠款</span>
                </div>
              </div>
              <div class="horizontal-list">
                <div class="horizontal-line" style="width:40%;"></div>
                <div class="horizontal-line" style="width:45%;"></div>
              </div>
              <div class="one-bill">
                <div>
                  <span>收款金额</span>
                  <div>
                    <span>{{allData.toDayAmountReceived?(allData.toDayAmountReceived/10000).toFixed(2):0}}</span>
                    <span>(万元)</span>
                  </div>
                  <span>今日</span>
                </div>
                <div class="vertical-line"></div>
                <div>
                  <div>
                    <span>{{allData.toMonthAmountReceived?(allData.toMonthAmountReceived/10000).toFixed(2):0}}</span>
                    <span>(万元)</span>
                  </div>
                  <span>本月</span>
                </div>
              </div>
            </div>
            <div class="data-echart">
              <div>
                <div class="echart-title">
                  <span>账单应收</span>
                  <span>(万元)</span>
                </div>
                <div class="echart-date">
                    <span @click="selectDate(0)">{{shouldDateSelect}}</span>
                    <van-icon
                     name="arrow-down"
                     size="0.4rem"
                     style="margin-right:0.1rem;"
                    />
                </div>
                <span class="echart-select" @click="allConfirm(1)">{{shouldAreaSelect}}</span>
                <van-icon
                  name="arrow-down"
                  size="0.4rem"
                  style="margin-right:0.1rem;"
                />
              </div>
              <div id="one-echart"></div>
              <div class="data-list">
                <div class="dataList-head">
                  <div class="td">区域/楼宇</div>
                  <div class="td">当期应收</div>
                  <div class="td">当期已收</div>
                  <div class="td">当期未收</div>
                  <div class="td">未收占比</div>
                </div>
                <div class="dataList-body" v-for="(item,index) in shouldData.list" :key="index">
                  <div class="td">{{item.name}}</div>
                  <div class="td">{{(item.bill_figure/10000).toFixed(2)}}</div>
                  <div class="td">{{(item.actual_received/10000).toFixed(2)}}</div>
                  <div class="td">{{(item.overdraft/10000).toFixed(2)}}</div>
                  <div class="td">{{item.percent}}%</div>
                </div>
              </div>
            </div>
            <div class="data-echart">
              <div>
                <div class="echart-title" style="margin-right:auto;">
                  <span>欠款账龄</span>
                  <span>(万元)</span>
                </div>
                <span class="echart-select" @click="allConfirm(2)">{{ageSelect}}</span>
                <van-icon
                  name="arrow-down"
                  size="0.4rem"
                  style="margin-right:0.1rem;"
                />
              </div>
              <div id="two-echart"></div>
            </div>
            <div class="data-rank">
              <div>
                <div class="echart-title">
                  <span>欠款排名</span>
                  <span>(万元)</span>
                </div>
                <span class="echart-select" @click="moreData">更多</span>
                <van-icon
                  name="arrow"
                  size="0.4rem"
                  style="margin-right:0.1rem;"
                />
              </div>
              <div class="rank-list">
                <div class="list-head">
                  <div class="td">客户名称</div>
                  <div class="td">租赁面积(m2)</div>
                  <div class="td">累计欠款</div>
                </div>
                <div class="list-body" v-for="(item,index) in cumulativeRankList" :key="index">
                  <div class="td">{{item.name}}</div>
                  <div class="td">{{item.rent_room_area}}</div>
                  <div class="td">{{(item.overdraft/10000).toFixed(2)}}</div>
                </div>
              </div>
            </div>
            <div class="data-echart">
              <div>
                <div class="echart-title" style="margin-right:auto;">
                  <span>未来趋势收入全部</span>
                  <span>(万元)</span>
                </div>
                <span class="echart-select" @click="allConfirm(3)">{{trendSelect}}</span>
                <van-icon
                  name="arrow-down"
                  size="0.4rem"
                  style="margin-right:0.1rem;"
                />
              </div>
              <div id="three-echart"></div>
            </div>
          </div>
        </van-tab>
        <van-tab title="租务">
          <div class="menu-content">
              <div class="rent-sum">
              <div>
                <span style="margin-right:auto;">租赁汇总</span>
                <!-- <div>
                    <span>2022-6</span>
                    <van-icon
                     name="arrow-down"
                     size="0.4rem"
                     style="margin-right:0.1rem;"
                    />
                </div> -->
                <span @click="allConfirm(4)">{{rentSelect}}</span>
                <van-icon
                  name="arrow-down"
                  size="0.4rem"
                  style="margin-right:0.1rem;"
                />
              </div>
              <div class="rent-area">
                  <span>本月租赁面积增长</span>
                  <span>{{rentSumData.old_area_sum?(rentSumData.new_area_sum-rentSumData.old_area_sum).toFixed(2):rentSumData.new_area_sum}}</span>
              </div>
              <div class="one-bill">
                <div>
                  <span>本月新签约面积</span>
                  <div>
                    <span>{{rentSumData.new_area_sum?rentSumData.new_area_sum:0}}</span>
                    <!-- <span>(万元)</span> -->
                    <span>合同</span>
                    <span>{{rentSumData.new_contract_total?rentSumData.new_contract_total:0}}</span>
                  </div>
                </div>
                <div class="vertical-line"></div>
                <div>
                  <span>本月已退租面积</span>
                  <div>
                    <span>{{rentSumData.old_area_sum?rentSumData.old_area_sum:0}}</span>
                    <!-- <span>(万元)</span> -->
                    <span>合同</span>
                    <span>{{rentSumData.old_contract_total?rentSumData.old_contract_total:0}}</span>
                  </div>
                </div>
              </div>
              <div class="horizontal-list" style="margin-top:0.3rem">
                <div class="horizontal-line" style="width:40%;"></div>
                <div class="horizontal-line" style="width:40%;"></div>
              </div>
              <div class="one-bill">
                <div>
                  <span>本月已续租面积</span>
                  <div>
                    <span>0</span>
                    <!-- <span>(万元)</span> -->
                    <span>合同</span>
                    <span>0</span>
                  </div>
                </div>
                <div class="vertical-line"></div>
                <div>
                  <span>本月已退租面积</span>
                  <div>
                    <span>0</span>
                    <!-- <span>(万元)</span> -->
                    <span>合同</span>
                    <span>0</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="data-echart">
              <div>
                <div class="echart-title" style="margin-right:auto;">
                  <span>租赁统计</span>
                </div>
                <!-- <div class="echart-date">
                    <span @click="selectDate(1)">{{countDateSelect}}</span>
                    <van-icon
                     name="arrow-down"
                     size="0.4rem"
                     style="margin-right:0.1rem;"
                    />
                </div> -->
                <span class="echart-select" @click="allConfirm(5)">{{countAreaSelect}}</span>
                <van-icon
                  name="arrow-down"
                  size="0.4rem"
                  style="margin-right:0.1rem;"
                />
              </div>
              <div id="four-echart"></div>
              <div class="data-list">
                <div class="dataList-head">
                  <div class="td">区域/楼宇</div>
                  <div class="td">总面积</div>
                  <div class="td">已租面积</div>
                  <div class="td">空置面积</div>
                  <div class="td">空置率</div>
                </div>
                <div class="dataList-body" v-for="(item,index) in rentCountData.lease_list" :key="index">
                  <div class="td">{{item.name}}</div>
                  <div class="td">{{item.all_room_area.toFixed(2)}}</div>
                  <div class="td">{{item.rented_area.toFixed(2)}}</div>
                  <div class="td">{{item.not_rented_area.toFixed(2)}}</div>
                  <div class="td">{{item.percent}}%</div>
                </div>
              </div>
            </div>
            <div class="data-echart">
              <div>
                <div class="echart-title" style="margin-right:auto;">
                  <span>空置时间占比</span>
                </div>
                <span class="echart-select" @click="allConfirm(6)">{{noRentSelect}}</span>
                <van-icon
                  name="arrow-down"
                  size="0.4rem"
                  style="margin-right:0.1rem;"
                />
              </div>
              <div id="five-echart"></div>
            </div>
            <div class="data-echart">
              <div>
                <div class="echart-title" style="margin-right:auto;">
                  <span>新签约面积趋势</span>
                </div>
                <span class="echart-select" @click="allConfirm(7)">{{newAreaSelect}}</span>
                <van-icon
                  name="arrow-down"
                  size="0.4rem"
                  style="margin-right:0.1rem;"
                />
              </div>
              <div id="six-echart" style="height:240px"></div>
            </div>
            <div class="data-echart">
              <div>
                <div class="echart-title" style="margin-right:auto;">
                  <span>未来合同到期面积趋势</span>
                </div>
                <span class="echart-select" @click="allConfirm(8)">{{futureAreaSelect}}</span>
                <van-icon
                  name="arrow-down"
                  size="0.4rem"
                  style="margin-right:0.1rem;"
                />
              </div>
              <div id="seven-echart" style="height:240px"></div>
            </div>
          </div>
        </van-tab>
        <van-tab title="能耗"> 
          <div class="menu-content">
            <div class="rent-sum">
              <div>
                <span style="margin-right:auto;">费用汇总</span>
                <!-- <div>
                    <span>2022-6</span>
                    <van-icon
                     name="arrow-down"
                     size="0.4rem"
                     style="margin-right:0.1rem;"
                    />
                </div> -->
                <span @click="allConfirm(9)">{{allEnergySelect}}</span>
                <van-icon
                  name="arrow-down"
                  size="0.4rem"
                  style="margin-right:0.1rem;"
                />
              </div>
              <div class="rent-area">
                  <span>当期结余电费<span style="font-size: 0.25rem;color: #666666;margin-left: 0.1rem;">(万元)</span></span>
                  <span>{{allEnergyData.balance_electricity?allEnergyData.balance_electricity.toFixed(2):0}}</span>
              </div>
              <div class="one-bill">
                <div>
                  <span>当期收取电费</span>
                  <div>
                    <span>{{allEnergyData.charge_electricity?allEnergyData.charge_electricity.toFixed(2):0}}</span>
                    <!-- <span>(万元)</span> -->
                  </div>
                </div>
                <div class="vertical-line"></div>
                <div>
                  <span>当期支出电费</span>
                  <div>
                    <span>{{allEnergyData.expend_electricity?allEnergyData.expend_electricity.toFixed(2):0}}</span>
                    <!-- <span>(万元)</span> -->
                  </div>
                </div>
              </div>
              <div class="divider-line"></div>
              <div class="rent-area">
                  <span>当期结余水费<span style="font-size: 0.25rem;color: #666666;margin-left: 0.1rem;">(万元)</span></span>
                  <span>{{allEnergyData.balance_water?allEnergyData.balance_water.toFixed(2):0}}</span>
              </div>
              <div class="one-bill">
                <div>
                  <span>当期收取水费</span>
                  <div>
                    <span>{{allEnergyData.charge_water?allEnergyData.charge_water.toFixed(2):0}}</span>
                    <!-- <span>(万元)</span> -->
                  </div>
                </div>
                <div class="vertical-line"></div>
                <div>
                  <span>当期支出水费</span>
                  <div>
                    <span>{{allEnergyData.expend_water?allEnergyData.expend_water.toFixed(2):0}}</span>
                    <!-- <span>(万元)</span> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="data-echart">
              <div>
                <div class="echart-title" style="margin-right:auto;">
                  <span>结余电费趋势</span>
                </div>
                <span class="echart-select" @click="allConfirm(10)">{{electricitySelect}}</span>
                <van-icon
                  name="arrow-down"
                  size="0.4rem"
                  style="margin-right:0.1rem;"
                />
              </div>
              <div id="eight-echart" style="height:240px"></div>
            </div>
            <div class="data-echart">
              <div>
                <div class="echart-title" style="margin-right:auto;">
                  <span>结余水费趋势</span>
                </div>
                <span class="echart-select" @click="allConfirm(11)">{{waterSelect}}</span>
                <van-icon
                  name="arrow-down"
                  size="0.4rem"
                  style="margin-right:0.1rem;"
                />
              </div>
              <div id="nine-echart" style="height:240px"></div>
            </div>
          </div>
        </van-tab>
        <van-tab title="工单">
          <div class="menu-content">
            <div class="rent-sum">
              <div>
                <span style="margin-right:auto;">工单汇总</span>
                <!-- <div>
                    <span>2022-6</span>
                    <van-icon
                     name="arrow-down"
                     size="0.4rem"
                     style="margin-right:0.1rem;"
                    />
                </div> -->
                <span @click="allConfirm(12)">{{orderSelect}}</span>
                <van-icon
                  name="arrow-down"
                  size="0.4rem"
                  style="margin-right:0.1rem;"
                />
              </div>
              <div class="rent-area">
                  <span>当期待处理工单</span>
                  <span>{{allOrderData.pending?allOrderData.pending:0}}</span>
              </div>
              <div class="one-bill">
                <div>
                  <span>当期新增工单</span>
                  <div>
                    <span>{{allOrderData.count?allOrderData.count:0}}</span>
                  </div>
                </div>
                <div class="vertical-line"></div>
                <div>
                  <span>当期已处理</span>
                  <div>
                    <span>{{allOrderData.processed?allOrderData.processed:0}}</span>
                  </div>
                </div>
              </div>
              <div class="horizontal-list" style="margin-top:0.3rem">
                <div class="horizontal-line" style="width:40%;"></div>
                <div class="horizontal-line" style="width:40%;"></div>
              </div>
              <div class="one-bill">
                <div>
                  <span>当期工单费用</span>
                  <div>
                    <span>{{allOrderData.expense?allOrderData.expense:0}}</span>
                  </div>
                </div>
                <div class="vertical-line"></div>
                <div>
                  <span>当期客户满意度</span>
                  <div>
                    <span>0%</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="data-echart">
              <div>
                <div class="echart-title" style="margin-right:auto;">
                  <span>工单占比</span>
                </div>
                <div class="echart-date">
                    <span @click="selectDate(1)">{{orderDateSelect}}</span>
                    <van-icon
                     name="arrow-down"
                     size="0.4rem"
                     style="margin-right:0.1rem;"
                    />
                </div>
                <span class="echart-select" @click="allConfirm(13)">{{orderPercentSelect}}</span>
                <van-icon
                  name="arrow-down"
                  size="0.4rem"
                  style="margin-right:0.1rem;"
                />
              </div>
              <div id="ten-echart" style="height:240px"></div>
              <div class="data-list">
                <div class="dataList-head">
                  <div class="td">区域/楼宇</div>
                  <div class="td">待处理工单</div>
                  <div class="td">客诉工单</div>
                  <div class="td">维修工单</div>
                  <div class="td">其他</div>
                </div>
                <div class="dataList-body" v-for="(item,index) in allOrderPencentData.data" :key="index">
                  <div class="td">{{item.name}}</div>
                  <div class="td">{{item.pending}}</div>
                  <div class="td">{{item.litigation}}</div>
                  <div class="td">{{item.repair}}</div>
                  <div class="td">{{item.other}}</div>
                </div>
              </div>
            </div>
            <div class="data-echart">
              <div>
                <div class="echart-title" style="margin-right:auto;">
                  <span>工单数量趋势</span>
                </div>
                <!-- <div class="echart-date">
                    <span @click="selectDate(1)">{{orderDateSelect}}</span>
                    <van-icon
                     name="arrow-down"
                     size="0.4rem"
                     style="margin-right:0.1rem;"
                    />
                </div> -->
                <span class="echart-select" @click="allConfirm(14)">{{orderTrendSelect}}</span>
                <van-icon
                  name="arrow-down"
                  size="0.4rem"
                  style="margin-right:0.1rem;"
                />
              </div>
              <div id="eleven-echart" style="height:240px"></div>
            </div>
            <div class="data-rank">
              <div>
                <div class="echart-title">
                  <span>客户满意度</span>
                </div>
              </div>
              <div class="client-list">
                <div class="list-head">
                  <div class="td">姓名</div>
                  <div class="td">处理数量</div>
                  <div class="td">平均时长（H）</div>
                  <div class="td">平均评分</div>
                </div>
                <div class="list-body" v-for="(item,index) in orderRankData" :key="index">
                  <div class="td">{{item.staff_name}}</div>
                  <div class="td">{{item.work_requests.toFixed(2)}}</div>
                  <div class="td">{{item.avg_handle_time.toFixed(2)}}</div>
                  <div class="td">无</div>
                </div>
              </div>
              <div class="moreData" v-if="orderRankDataLength>5" @click="getOrderRankData('more')">更多</div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <!-- 区域/楼宇选择 -->
    <!-- <van-action-sheet v-model="areaShow">
      <van-picker
        title="区域"
        show-toolbar
        value-key="name"
        :columns="areaActions"
        @confirm="areaSelect"
        @cancel="areaShow = false"
      />
    </van-action-sheet> -->
    <van-popup v-model="areaShow" position="bottom">
      <div>
        <div class="pop-title">
          <span>请选择</span>
          <span @click="areaSelect">确定</span>
        </div>
        <div class="tab-content">
          <van-tabs v-model="addressActive">
            <van-tab title="请选择区域">
              <div class="list-content">
                <div :style="{ color: areaSelected=='all'?'#3293FD':'#323233'}" @click="selectAllArea">全部</div>
                <div v-for="(item,index) in areaArr" :key="index" @click="selectArea(item,index)" :style="{ color: areaSelected==index?'#3293FD':'#323233'}">{{item.name}}</div>
              </div>
            </van-tab>
            <van-tab title="请选择楼宇">
              <div class="list-content">
                <div :style="{ color: buildSelected=='all'?'#3293FD':'#323233'}" @click="selectAllBuild">全部</div>
                <div v-for="(item,index) in buildArr" :key="index" @click="selectBuild(item,index)" :style="{ color: buildSelected==index?'#3293FD':'#323233'}">{{item.name}}</div>
              </div>
            </van-tab>
          </van-tabs>
        </div>
      </div>
    </van-popup>
    <!-- 日期选择 -->
    <!-- <van-action-sheet v-model="dateShow">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="dateSelect"
        @cancel="dateShow = false"
      />
    </van-action-sheet> -->
    <!-- 时间日期选择 -->
    <van-popup v-model="dateShow" position="bottom">
      <div>
        <div class="date-title">
          <span @click="dateShow=false">取消</span>
          <span>请选择</span>
          <span @click="dateConfirm">确定</span>
        </div>
        <div class="type-select">
          <span :style="{ background: currentSelect==0?'#1484FF':'#FFFFFF',color: currentSelect==0?'#FFFFFF':'#1484FF'}" @click="currentSelect=0">按月</span>
          <span :style="{ background: currentSelect==1?'#1484FF':'#FFFFFF',color: currentSelect==1?'#FFFFFF':'#1484FF'}" @click="currentSelect=1">范围</span>
        </div>
        <div class="date-selector">
          <div class="one-div" v-if="currentSelect==0">
            <van-datetime-picker
              v-model="singleDate"
              type="year-month"
              title="选择年月"
              :min-date="minDate"
              :max-date="maxDate"
              :formatter="formatter"
            />
          </div>
          <div class="two-div" v-else>
            <van-datetime-picker
              v-model="comboOneDate"
              type="year-month"
              title="选择年月"
              :min-date="minDate"
              :max-date="maxDate"
              :formatter="formatter"
            />
            <span>至</span>
            <van-datetime-picker
              v-model="comboTwoDate"
              type="year-month"
              title="选择年月"
              :min-date="minDate"
              :max-date="maxDate"
              :formatter="formatter"
            />
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { amountSum,areaList,billsShould,cumulativeAge,revenueTrend,rentSum,rentCount,noRentPercent,newAreaTrend,allEnergyData,restData,allOrderData,allPercentData,allTrendData,orderRankData } from "../axios/property";
export default {
  components: {},
  data() {
    return {
      companyId: "",
      active: 0,
      addressActive: 0,
      currentSelect: 0,
      areaArr: [],
      buildArr: [],
      areaSelected: 'all',
      buildSelected: 'all',
      singleDate: new Date(),
      comboOneDate: new Date(),
      comboTwoDate: new Date(),
      allForm: { // 财务汇总表单数据
        rentAreaId: ''
      },
      shouldForm: { // 账单应收表单数据
        rentAreaId: '',
      },
      ageForm: { // 欠款账龄表单数据
        rentAreaId: '',
      },
      trendForm: { // 未来收入趋势表单数据
        rentAreaId: '',
      },
      rentForm: { // 租赁汇总表单数据
        rentAreaId: '',
      },
      countForm: { // 租赁统计表单数据
        rentAreaId: '',
      },
      noRentForm: { // 空置时间占比表单
        rentAreaId: '',
      },
      newAreaForm: { // 新签约面积趋势
        rentAreaId: '',
      },
      futureAreaForm: { // 未来合同到期面积趋势
        rentAreaId: '',
      },
      allEnergyForm: { // 能耗费用汇总表单
        rentAreaId: '',
      },
      electricityForm: { // 结余电费表单
        rentAreaId: '',
      },
      waterForm: { // 结余水费表单
        rentAreaId: '',
      },
      orderForm: { // 工单汇总表单
        rentAreaId: '',
      },
      orderPercentForm: { // 工单统计表单
        rentAreaId: '',
      },
      orderTrendForm: { // 工单数量趋势表单
        rentAreaId: '',
      },
      addressForm: { // 地址表单筛选
        mainType: 1,
        rentAreaId: "",
        rentBuildingId: ""
      },
      allData: {},
      shouldData: {},
      cumulativeData: {},
      rentSumData: {},
      rentCountData: {},
      noRentData: {},
      allEnergyData: {},
      allOrderData: {},
      allOrderPencentData: {},
      selectText: "",
      allAreaSelect: '全部',
      shouldAreaSelect: '全部',
      shouldDateSelect: '选择日期',
      countDateSelect: '选择日期',
      orderDateSelect: '选择日期',
      countAreaSelect: '全部',
      noRentSelect: '全部',
      newAreaSelect: '全部',
      futureAreaSelect: '全部',
      ageSelect: '全部',
      trendSelect: '全部',
      rentSelect: '全部',
      allEnergySelect: '全部',
      electricitySelect: '全部',
      waterSelect: '全部',
      orderSelect: '全部',
      orderPercentSelect: '全部',
      orderTrendSelect: '全部',
      areaShow: false,
      dateShow: false,
      areaActions: [{name:'全部'}],
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      areaActive: 0, // 操作哪一项的区域选择器
      dateActive: 0, // 操作哪一项的日期选择器
      shouldSalaryList: [], // 账单应收
      cumulativeAgeList: [], // 欠款账龄数据
      cumulativeRankList: [], // 欠款排名数据
      trendDataList: [], // 未来收入趋势金额数据
      trendDateList: [], // 未来收入趋势日期数据
      rentCountList: [], // 租赁统计数据
      noRentCountList: [], // 空置时间占比
      newDateList: [], // 新签约面积趋势日期数据
      newDataList: [], // 新签约面积趋势数据
      futureDateList: [], // 未来合同到期面积趋势日期数据
      futureDataList: [], // 未来合同到期面积趋势数据
      restElectricityDateList: [], // 结余电费日期数据
      restWaterDateList: [], // 结余水费日期数据
      electricityDataList: [], // 结余电费数据
      waterDataList: [], // 结余水费数据
      orderPercentList: [], // 工单占比数据
      orderDateList: [], // 工单数量趋势日期数据
      orderDataList: [], // 工单数量趋势数据
      orderRankData: [], // 工单客户满意度排名数据
      orderRankDataLength: 0, // 工单客户满意度排名数据数量
    };
  },
  created() {
    this.companyId = this.$store.state.initialData.companyId
    this.getAreaList();
    this.getAllData();
    this.getBillShould();
    this.getCumulativeAge();
    this.getCumulativeRank();
    this.getRevenueData();
  },
  mounted(){
    this.getAllData();
  },
  methods: {
    selectBuild(obj,index){ // 选择楼宇
      console.log(obj)
      this.buildSelected = index
      this.addressForm.rentBuildingId=obj.id
      this.addressForm.mainType=2
      this.selectText = obj.name
    },
    selectAllBuild(){ // 选择全部楼宇
      this.officeSelect = 'all'
      this.addressForm.rentBuildingId=""
      this.addressForm.mainType=2
      this.selectText = '全部楼宇'
    },
    selectArea(obj,index){ // 选择区域
      console.log(obj)
      this.areaSelected = index
      this.buildArr = obj.childList
      this.addressForm.rentAreaId=obj.id
      this.addressForm.mainType=1
      this.selectText = obj.name
    },
    selectAllArea(){ // 选择全部区域
      this.areaSelected = 'all'
      this.addressForm.rentAreaId=""
      this.addressForm.mainType=1
      this.buildArr = []
      this.selectText = '全部区域'
    },
    // confirmSelect(){ // 确认区域/楼宇选择
    //   this.companySelectShow = false
    //   this.companySelectConfirmText = this.companySelectText
    //   this.timeSelectConfirmText = this.timeSelectText
    //   this.getAllData()
    // },
    formatter(type, val) { // 日期选择器格式转换
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    allConfirm(index){ // 弹出区域选择器
      this.areaActive = index;
      this.areaShow = true
    },
    selectDate(index){ // 弹出日期选择器
      this.dateActive = index;
      this.dateShow = true
    },
    getAreaList(){ // 获取区域选择器option数据
      let that = this
      let data = {
        companyId: this.companyId,
      };
      areaList(data).then((res) => {
        console.log(res);
        if(res.data.code==0){
          for(let i=0;i<res.data.data.length;i++){
            that.areaArr.push(res.data.data[i])
          }
        }
      });
    },
    getAllData() { // 获取财务汇总数据
      let that = this;
      let requestData = {
        comId: this.companyId,
        ...this.allForm
      };
      amountSum(requestData).then(res=>{
        console.log(res)
        if(res.data.code==0){
          that.allData = res.data.data
        }
      })
    },
    getBillShould(){ // 获取账单应收数据
      let that = this;
      this.shouldSalaryList = []
      let requestData = {
        comId: this.companyId,
        mainType: 1,
        ...this.shouldForm
      };
      billsShould(requestData).then(res=>{
        console.log(res)
        if(res.data.code==0){
            that.shouldData = res.data.data
            for(let i=0;i<that.shouldData.list.length;i++){
              that.shouldData.list[i].percent = ((that.shouldData.list[i].overdraft/that.shouldData.list[i].bill_figure).toFixed(2))*100
            }
            that.shouldSalaryList.push({name: '当期已收',value:(that.shouldData.actualReceived/10000).toFixed(2)},{name: '当期未收',value:(that.shouldData.billArrears/10000).toFixed(2)})
            that.myOneEcharts()
        }
      })
    },
    getCumulativeAge(){ // 获取欠款账龄数据
      let that = this;
      this.cumulativeAgeList = []
      let requestData = {
        comId: this.companyId,
        ...this.ageForm
      };
      cumulativeAge(requestData).then(res=>{
        console.log(res)
        let arr = [] // 时间分类数组
        if(res.data.code==0){
          let responseData = res.data.data
          arr = [
            {name: '小于30天', value: 0},
            {name: '30～60天', value: 0},
            {name: '60～90天', value: 0},
            {name: '90～120天', value: 0},
            {name: '120～180天', value: 0},
            {name: '180～360天', value: 0}
          ]
          for(let i=0;i<responseData.length;i++){
            if(responseData[i].age<30){
              arr[0].value+=responseData[i].overdraft
            }
            if(responseData[i].age>=30&&responseData[i].age<60){
              arr[1].value+=responseData[i].overdraft
            }
            if(responseData[i].age>=60&&responseData[i].age<90){
              arr[2].value+=responseData[i].overdraft
            }
            if(responseData[i].age>=90&&responseData[i].age<120){
              arr[3].value+=responseData[i].overdraft
            }
            if(responseData[i].age>=120&&responseData[i].age<180){
              arr[4].value+=responseData[i].overdraft
            }
            if(responseData[i].age>=180&&responseData[i].age<360){
              arr[5].value+=responseData[i].overdraft
            }
          }
          for(let i in arr){
            arr[i].value = (arr[i].value/10000).toFixed(2)
          }
          that.cumulativeAgeList = arr
          that.myTwoEcharts()
          // console.log(that.shouldData)
        }
      })
    },
    getCumulativeRank(){ // 欠款排名
      let that = this;
      let requestData = {
        comId: this.companyId,
        time: 1,
        ...this.shouldForm
      };
      that.cumulativeRankList = []
      billsShould(requestData).then(res=>{
        console.log(res)
        if(res.data.code==0){
          console.log(this.cumulativeRankList)
          for(let i=0;i<res.data.data.list.length;i++){
            if(i<5){
              that.cumulativeRankList.push(res.data.data.list[i])
            }
          }
        }
      })
    },
    getRevenueData(){ // 获取未来收入趋势数据
      let that = this;
      let requestData = {
        comId: this.companyId,
        ...this.trendForm
      };
      this.trendDataList = []
      this.trendDateList = []
      revenueTrend(requestData).then(res=>{
        console.log(res)
        if(res.data.code==0){
          let arr = res.data.data.reverse()
          for(let i=0;i<arr.length;i++){
            that.trendDataList.push((parseFloat(arr[i].amount)/10000).toFixed(2))
            that.trendDateList.push(arr[i].time)
          }
          that.myThreeEcharts()
        }
      })
    },
    getRentSumData(){ // 获取租赁汇总数据
      let that = this;
      let requestData = {
        comId: this.companyId,
        ...this.rentForm
      };
      rentSum(requestData).then(res=>{
        if(res.data.code==0){
          console.log(res)
          that.rentSumData = res.data.data
        }
      })
    },
    getRentCountData(){ // 获取租赁统计数据
      let that = this;
      this.rentCountList = []
      let requestData = {
        comId: this.companyId,
        mainType: 1,
        ...this.countForm
      };
      rentCount(requestData).then(res=>{
        console.log(res)
        if(res.data.code==0){
            that.rentCountData = res.data.data
            for(let i=0;i<that.rentCountData.lease_list.length;i++){
              that.rentCountData.lease_list[i].percent = ((that.rentCountData.lease_list[i].not_rented_area/that.rentCountData.lease_list[i].all_room_area).toFixed(2))*100
            }
            that.rentCountList.push({name: '已租',value:that.rentCountData.rented_area.toFixed(2)},{name: '空置',value:that.rentCountData.not_rented_area.toFixed(2)})
            that.myFourEcharts()
        }
      })
    },
    getNoRentData(){ // 获取空置面积时间占比数据
      let that = this;
      let requestData = {
        comId: this.companyId,
        mainType: 1,
        ...this.noRentForm
      };
      this.noRentCountList = []
      let all_area = 0 // 空置总面积
      let arr = [
            {name: '小于30天', value: 0},
            {name: '30～90天', value: 0},
            {name: '90～180天', value: 0},
            {name: '180～360天', value: 0},
            {name: '大于360天', value: 0}
          ]
      noRentPercent(requestData).then(res=>{
        console.log(res)
        let responseData = res.data.data
        if(res.data.code==0){
          for(let i=0;i<responseData.length;i++){
            all_area += responseData[i].all_room_area
          }
          that.noRentData.all_area = all_area
          for(let i=0;i<responseData.length;i++){
            arr[0].value+=responseData[i]["0-30"]
            arr[1].value+=responseData[i]["30-90"]
            arr[2].value+=responseData[i]["90-180"]
            arr[3].value+=responseData[i]["180-360"]
            arr[4].value+=responseData[i]["360+"]
          }
          that.noRentCountList = arr
          that.myFiveEcharts()
        }
      })
    },
    getNewAreaData(){ // 新签约面积趋势数据
      let that = this;
      this.newDateList = []
      this.newDataList = []
      let requestData = {
        comId: this.companyId,
        mainType: 1,
        time: 1,
        num: 6,
        ...this.newAreaForm
      };
      newAreaTrend(requestData).then(res=>{
        console.log(res)
        if(res.data.code==0){
          let arr = res.data.data[0].list.reverse()
          for(let i=0;i<arr.length;i++){
            that.newDateList.push(arr[i].time)
          }
          let bigArr = res.data.data
          let everyOption = []
          for(let i=0;i<bigArr.length;i++){
            everyOption = []
            for(let j=0;j<bigArr[i].list.length;j++){
              everyOption.push(bigArr[i].list[j].area)
            }
            that.newDataList.push({
              name: bigArr[i].name,
              type: 'bar',
              stack: 'Ad',
              barWidth: 10,
              emphasis: {
                focus: 'series'
              },
              data: everyOption
            })
          }
          console.log(that.newDateList)
          console.log(that.newDataList)
          that.mySixEcharts()
        }
      })
    },
    getFutureAreaData(){ // 未来合同到期面积趋势数据
      let that = this;
      this.futureDateList = []
      this.futureDataList = []
      let requestData = {
        comId: this.companyId,
        mainType: 1,
        time: 0,
        num: 6,
        ...this.futureAreaForm
      };
      newAreaTrend(requestData).then(res=>{
        console.log(res)
        if(res.data.code==0){
          let arr = res.data.data[0].list
          for(let i=0;i<arr.length;i++){
            that.futureDateList.push(arr[i].time)
          }
          let bigArr = res.data.data
          let everyOption = []
          for(let i=0;i<bigArr.length;i++){
            everyOption = []
            for(let j=0;j<bigArr[i].list.length;j++){
              everyOption.push(bigArr[i].list[j].area)
            }
            that.futureDataList.push({
              name: bigArr[i].name,
              type: 'bar',
              stack: 'Ad',
              barWidth: 10,
              emphasis: {
                focus: 'series'
              },
              data: everyOption
            })
          }
          that.mySevenEcharts()
        }
      })
    },
    getEnergyData(){ // 获取能耗费用汇总数据
      let that = this;
      let requestData = {
        comId: this.companyId,
        ...this.allEnergyForm
      };
      if(requestData.rentAreaId==""){
        delete requestData.rentAreaId
      }
      allEnergyData(requestData).then(res=>{
        console.log(res)
        if(res.data.code==0){
          that.allEnergyData = res.data.data
        }
      })
    },
    getElectricityData(){ // 获取结余电费趋势数据
      let that = this;
      this.restElectricityDateList = []
      this.electricityDataList = []
      let requestData = {
        comId: this.companyId,
        num: 12,
        ...this.electricityForm
      };
      restData(requestData).then(res=>{
        console.log(res)
        if(res.data.code==0){
          let arr = res.data.data.reverse()
          for(let i=0;i<arr.length;i++){
            that.electricityDataList.push((parseFloat(arr[i].data.balance_electricity)/10000).toFixed(2))
            that.restElectricityDateList.push(arr[i].time)
          }
          that.myEightEcharts()
        }
      })
    },
    getWaterData(){ // 获取结余水费趋势数据
      let that = this;
      this.restWaterDateList = []
      this.waterDataList = []
      let requestData = {
        comId: this.companyId,
        num: 12,
        ...this.waterForm
      };
      restData(requestData).then(res=>{
        console.log(res)
        if(res.data.code==0){
          let arr = res.data.data.reverse()
          for(let i=0;i<arr.length;i++){
            that.waterDataList.push((parseFloat(arr[i].data.balance_water)/10000).toFixed(2))
            that.restWaterDateList.push(arr[i].time)
          }
          that.myNineEcharts()
        }
      })
    },
    getOrderData(){ // 获取工单汇总数据
      let that = this;
      let requestData = {
        comId: this.companyId,
        ...this.orderForm
      };
      allOrderData(requestData).then(res=>{
        console.log(res)
        if(res.data.code==0){
          that.allOrderData = res.data.data
        }
      })
    },
    getOrderPencentData(){ // 获取工单占比数据
      let that = this;
      let requestData = {
        comId: this.companyId,
        ...this.orderPercentForm
      };
      allPercentData(requestData).then(res=>{
        console.log(res)
        if(res.data.code==0){
            that.allOrderPencentData = res.data.data
            that.orderPercentList.push({name: '客诉工单',value:that.allOrderPencentData.litigation},{name: '维修工单',value:that.allOrderPencentData.repair})
            that.myTenEcharts()
        }
      })
    },
    getOrderTrendData(){ // 获取工单数量趋势数据
      let that = this;
      this.orderDateList = []
      this.orderDataList = []
      let requestData = {
        comId: this.companyId,
        num: 6,
        ...this.orderTrendForm
      };
      allTrendData(requestData).then(res=>{
        console.log(res)
        if(res.data.code==0){
          let arr = res.data.data.reverse()
          for(let i=0;i<arr.length;i++){
            that.orderDateList.push(arr[i].time)
          }
          let bigArr = res.data.data
          let newOrder = []
          let processedOrder = []
          let pendingOrder = []
          for(let i=0;i<bigArr.length;i++){
            newOrder.push(bigArr[i].data.count)
            processedOrder.push(bigArr[i].data.processed)
            pendingOrder.push(bigArr[i].data.pending)
          }
          that.orderDataList = [
            {
              name: '新增工单',
              type: 'bar',
              barWidth: 10,
              emphasis: {
                focus: 'series'
              },
              data: newOrder
            },
            {
              name: '已处理工单',
              type: 'bar',
              barWidth: 10,
              emphasis: {
                focus: 'series'
              },
              data: processedOrder
            },
            {
              name: '待处理工单',
              type: 'bar',
              barWidth: 10,
              emphasis: {
                focus: 'series'
              },
              data: pendingOrder
            }
          ]
          that.myElevenEcharts()
        }
      })
    },
    getOrderRankData(isMore){ // 获取工单客户满意度数据
      let that = this;
      that.orderRankData = []
      let requestData = {
        comId: this.companyId
      };
      orderRankData(requestData).then(res=>{
        console.log(res)
        if(res.data.code==0){
          that.orderRankDataLength = res.data.data.length
          if(isMore){
            that.orderRankData = res.data.data
            that.orderRankDataLength = 0
          } else {
            for(let i=0;i<res.data.data.length;i++){
              if(i<=4){
                that.orderRankData.push(res.data.data[i])
              }
            }
          }
        }
      })
    },
    areaSelect() {
      // 更改区域
      if(this.areaActive == 0){
        this.allForm = {...this.addressForm}
        this.allAreaSelect = this.selectText
        this.getAllData();
      } else if(this.areaActive == 1){
        this.shouldForm = {...this.addressForm}
        this.shouldAreaSelect = this.selectText
        this.getBillShould();
      } else if(this.areaActive == 2){
        this.ageForm = {...this.addressForm}
        this.ageSelect = this.selectText
        this.getCumulativeAge();
      } else if(this.areaActive == 3){
        this.trendForm = {...this.addressForm}
        this.trendSelect = this.selectText
        this.getRevenueData();
      } else if(this.areaActive == 4){
        this.rentForm = {...this.addressForm}
        this.rentSelect = this.selectText
        this.getRentSumData();
      } else if(this.areaActive == 5){
        this.countForm = {...this.addressForm}
        this.countAreaSelect = this.selectText
        this.getRentCountData();
      } else if(this.areaActive == 6){
        this.noRentForm = {...this.addressForm}
        this.noRentSelect = this.selectText
        this.getNoRentData();
      } else if(this.areaActive == 7){
        this.newAreaForm = {...this.addressForm}
        this.newAreaSelect = this.selectText
        this.getNewAreaData();
      } else if(this.areaActive == 8){
        this.futureAreaForm = {...this.addressForm}
        this.futureAreaSelect = this.selectText
        this.getFutureAreaData();
      } else if(this.areaActive == 9){
        this.allEnergyForm = {...this.addressForm}
        this.allEnergySelect = this.selectText
        this.getEnergyData();
      } else if(this.areaActive == 10){
        this.electricityForm = {...this.addressForm}
        this.electricitySelect = this.selectText
        this.getElectricityData();
      } else if(this.areaActive == 11){
        this.waterForm = {...this.addressForm}
        this.waterSelect = this.selectText
        this.getWaterData();
      } else if(this.areaActive == 12){
        this.orderForm = {...this.addressForm}
        this.orderSelect = this.selectText
        this.getOrderData();
      } else if(this.areaActive == 13){
        this.orderPercentForm = {...this.addressForm}
        this.orderDateSelect = this.selectText
        this.getOrderPencentData();
      } else if(this.areaActive == 14){
        this.orderTrendForm = {...this.addressForm}
        this.orderTrendSelect = this.selectText
        this.getOrderTrendData();
      }
      this.areaShow = false;
    },
    dateConfirm(){ // 日期选择框确认
      console.log(this.singleDate.getMonth()+1)
      if(this.currentSelect==0){
        let year = this.singleDate.getFullYear()
        let startMonth = this.singleDate.getMonth()+1
        let endMonth = this.singleDate.getMonth()+2
        if(startMonth<10){
          startMonth = '0' + startMonth
        }
        if(endMonth<10){
          endMonth = '0' + endMonth
        }
        let dateString = year + '-' + startMonth
        if(this.dateActive == 0){
          this.shouldDateSelect = dateString
          this.shouldForm.startTime = new Date(dateString).getTime()
          this.shouldForm.endTime = new Date(year + '-' + endMonth).getTime()
          this.getBillShould();
        } else if(this.dateActive == 1){
          this.orderDateSelect = dateString
          this.orderPercentForm.startTime = new Date(dateString).getTime()
          this.orderPercentForm.endTime = new Date(year + '-' + endMonth).getTime()
          this.getOrderPencentData();
        }
      } else {
        let startYear = this.comboOneDate.getFullYear()
        let startMonth = this.comboOneDate.getMonth()+1
        let endYear = this.comboTwoDate.getFullYear()
        let endMonth = this.comboTwoDate.getMonth()+1
        if(startMonth<10){
          startMonth = '0' + startMonth
        }
        if(endMonth<10){
          endMonth = '0' + endMonth
        }
        let startDate = startYear + '-' + startMonth
        let endDate = endYear + '-' + endMonth
        if(this.dateActive == 0){
          this.shouldDateSelect = startDate + ' ~ ' + endDate
          this.shouldForm.startTime = new Date(startDate).getTime()
          this.shouldForm.endTime = new Date(endDate).getTime()
          this.getBillShould();
        } else if(this.dateActive == 1){
          this.orderDateSelect = startDate + ' ~ ' + endDate
          this.orderPercentForm.startTime = new Date(startDate).getTime()
          this.orderPercentForm.endTime = new Date(endDate).getTime()
          this.getOrderPencentData();
        }
      }
      this.dateShow = false
    },
    myOneEcharts() {
      let that = this;
      var myChart = this.$echarts.init(document.getElementById("one-echart"));
      //配置图表
      var option = {
        tooltip: {
          trigger: "item",
        },
        color: [
          "#1584FF",
          "#FF5215",
          "#29EBB6",
          "#F6D816",
          "#8848E1",
          "#4855E1",
          "#48E178",
          "#B1E148",
          "#E148B2",
          "#CB48E1",
        ],
        title: [
          {
            text: (this.shouldData.billFigure / 10000).toFixed(2),
            left: this.shouldData.billFigure>0?"13.5%":"18%",
            top: "40%",
            textStyle: {
              fontSize: 18,
              color: "#333333",
              align: "center",
            },
          },
          {
            text: "当期应收",
            left: "17.5%",
            top: "52%",
            textStyle: {
              fontSize: 10,
              color: "#999999",
              align: "right",
            },
          },
        ],
        legend: {
          type: "scroll",
          orient: "vertical",
          height: "50%",
          textStyle: {
            rich: {
              name: {
                fontSize: 10,
                color: "#666666",
                width: 50,
                padding: [0, 0, 0, 0],
              },
              num: {
                fontSize: 14,
                fontWeight: 600,
                width: 95,
                padding: [0, 0, 0, 0],
                color: "#333333",
              }
            },
          },
          formatter: function(name) {
            let tarValue;
            if (that.shouldSalaryList.length > 0) {
              for (let i = 0; i < that.shouldSalaryList.length; i++) {
                if (that.shouldSalaryList[i].name == name) {
                  tarValue = that.shouldSalaryList[i].value;
                }
              }
              return [`{name|${name}} {num|${tarValue}}`];
            }
          },
          icon: "circle",
          top: "35%",
          right: "6%",
        },
        series: [
          {
            name: "应发薪资",
            type: "pie",
            radius: ["50%", "70%"],
            center: ["25%", "50%"],
            label: {
              show: false,
              position: "inside",
              formatter: "{d}%",
            },
            labelLine: {
              show: false,
            },
            data: this.shouldSalaryList
          },
        ],
      };
      myChart.setOption(option);
    },
    myTwoEcharts() {
      let that = this;
      let cumulativeMoney = 0
      for(let i in this.cumulativeAgeList){
        cumulativeMoney+=parseFloat(this.cumulativeAgeList[i].value)
      }
      console.log(this.cumulativeAgeList)
      var myChart = this.$echarts.init(document.getElementById("two-echart"));
      //配置图表
      var option = {
        tooltip: {
          trigger: "item",
        },
        color: [
          "#1584FF",
          "#FF5215",
          "#29EBB6",
          "#F6D816",
          "#8848E1",
          "#4855E1",
          "#48E178",
          "#B1E148",
          "#E148B2",
          "#CB48E1",
        ],
        title: [
          {
            text: cumulativeMoney.toFixed(2),
            left: cumulativeMoney>0?"12%":"18%",
            top: "40%",
            textStyle: {
              fontSize: 18,
              color: "#333333",
              align: "center",
            },
          },
          {
            text: "累计欠款",
            left: "17.5%",
            top: "52%",
            textStyle: {
              fontSize: 10,
              color: "#999999",
              align: "right",
            },
          },
        ],
        legend: {
          type: "scroll",
          orient: "vertical",
          height: "100%",
          textStyle: {
            rich: {
              name: {
                fontSize: 10,
                color: "#666666",
                width: 60,
                padding: [0, 0, 0, 0],
              },
              num: {
                fontSize: 14,
                fontWeight: 600,
                width: 95,
                padding: [0, 0, 0, 0],
                color: "#333333",
              }
            },
          },
          formatter: function(name) {
            let tarValue;
            if (that.cumulativeAgeList.length > 0) {
              for (let i = 0; i < that.cumulativeAgeList.length; i++) {
                if (that.cumulativeAgeList[i].name == name) {
                  tarValue = that.cumulativeAgeList[i].value;
                }
              }
              return [`{name|${name}} {num|${tarValue}}`];
            }
          },
          icon: "circle",
          top: "12%",
          right: "5%",
        },
        series: [
          {
            name: "应发薪资",
            type: "pie",
            radius: ["50%", "70%"],
            center: ["25%", "50%"],
            label: {
              show: false,
              position: "inside",
              formatter: "{d}%",
            },
            labelLine: {
              show: false,
            },
            data: this.cumulativeAgeList
          },
        ],
      };
      myChart.setOption(option);
    },
    myThreeEcharts() {
      console.log(this.trendDataList)
      console.log(this.trendDateList)
      var myChart = this.$echarts.init(document.getElementById("three-echart"));
      //配置图表
      var option = {
        legend: {
          top: "10",
          left: 10,
          icon: "roundRect",
          show: false
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: "10%",
          left: "18%",
          height: "80%"
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.trendDateList,
          axisLabel: {
            color: '#999999'
          },
          axisLine: {
            lineStyle: {
              color: '#E2E2E2'
            }
          },
          axisTick: {
            show: false,
            lineStyle: {
              color: '#333333'
            }
          }
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#999999'
          },
          splitLine: {
            lineStyle: {
              color: '#999999',
              type: 'dashed',
              opacity: 0.2
            }
          }
        },
        series: [
          {
            name: "收入趋势",
            type: "line",
            stack: "Total",
            symbol: "circle",
            smooth: true,
            areaStyle: {
              opacity: 0.5,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#1584FF",
                },
                {
                  offset: 1,
                  color: "#429CFF",
                },
              ]),
            },
            itemStyle: {
              normal: {
                color: "#1484FF", //改变折线点的颜色
                lineStyle: {
                  color: "rgb(176, 220, 249)", //改变折线颜色
                },
              },
            },
            data: this.trendDataList,
          }
        ],
      };
      myChart.setOption(option);
    },
    myFourEcharts(){
      let that = this;
      var myChart = this.$echarts.init(document.getElementById("four-echart"));
      //配置图表
      var option = {
        tooltip: {
          trigger: "item",
        },
        color: [
          "#1584FF",
          "#FF5215",
          "#29EBB6",
          "#F6D816",
          "#8848E1",
          "#4855E1",
          "#48E178",
          "#B1E148",
          "#E148B2",
          "#CB48E1",
        ],
        title: [
          {
            text: this.rentCountData.all_area.toFixed(2),
            left: this.rentCountData.all_area==0?"17%":this.rentCountData.all_area>0&&this.rentCountData.all_area<1000?"15%":"10%",
            top: "40%",
            textStyle: {
              fontSize: 18,
              color: "#333333",
              align: "center",
            },
          },
          {
            text: "总面积",
            left: "19%",
            top: "53%",
            textStyle: {
              fontSize: 10,
              color: "#999999",
              align: "right",
            },
          },
        ],
        legend: {
          type: "scroll",
          orient: "vertical",
          height: "50%",
          textStyle: {
            rich: {
              name: {
                fontSize: 10,
                color: "#666666",
                width: 30,
                padding: [0, 0, 0, 0],
              },
              num: {
                fontSize: 14,
                fontWeight: 600,
                width: 95,
                padding: [0, 0, 0, 0],
                color: "#333333",
              }
            },
          },
          formatter: function(name) {
            let tarValue;
            if (that.rentCountList.length > 0) {
              for (let i = 0; i < that.rentCountList.length; i++) {
                if (that.rentCountList[i].name == name) {
                  tarValue = that.rentCountList[i].value;
                }
              }
              return [`{name|${name}} {num|${tarValue}}`];
            }
          },
          icon: "circle",
          top: "35%",
          right: "7%",
        },
        series: [
          {
            name: "租赁统计",
            type: "pie",
            radius: ["60%", "80%"],
            center: ["25%", "50%"],
            label: {
              show: false,
              position: "inside",
              formatter: "{d}%",
            },
            labelLine: {
              show: false,
            },
            data: this.rentCountList
          },
        ],
      };
      myChart.setOption(option);
    },
    myFiveEcharts(){
      let that = this;
      var myChart = this.$echarts.init(document.getElementById("five-echart"));
      //配置图表
      var option = {
        tooltip: {
          trigger: "item",
        },
        color: [
          "#1584FF",
          "#FF5215",
          "#29EBB6",
          "#F6D816",
          "#8848E1",
          "#4855E1",
          "#48E178",
          "#B1E148",
          "#E148B2",
          "#CB48E1",
        ],
        title: [
          {
            text: this.noRentData.all_area.toFixed(2),
            left: this.noRentData.all_area==0?"17%":this.noRentData.all_area>0&&this.noRentData.all_area<1000?"15%":"10%",
            top: "40%",
            textStyle: {
              fontSize: 18,
              color: "#333333",
              align: "center",
            },
          },
          {
            text: "空置总面积",
            left: "16.5%",
            top: "53%",
            textStyle: {
              fontSize: 10,
              color: "#999999",
              align: "right",
            },
          },
        ],
        legend: {
          type: "scroll",
          orient: "vertical",
          height: "70%",
          textStyle: {
            rich: {
              name: {
                fontSize: 10,
                color: "#666666",
                width: 60,
                padding: [0, 0, 0, 0],
              },
              num: {
                fontSize: 14,
                fontWeight: 600,
                width: 95,
                padding: [0, 0, 0, 0],
                color: "#333333",
              }
            },
          },
          formatter: function(name) {
            let tarValue;
            if (that.noRentCountList.length > 0) {
              for (let i = 0; i < that.noRentCountList.length; i++) {
                if (that.noRentCountList[i].name == name) {
                  tarValue = that.noRentCountList[i].value;
                }
              }
              return [`{name|${name}} {num|${tarValue}}`];
            }
          },
          icon: "circle",
          top: "18%",
          right: "5%",
        },
        series: [
          {
            name: "租赁统计",
            type: "pie",
            radius: ["60%", "80%"],
            center: ["25%", "50%"],
            label: {
              show: false,
              position: "inside",
              formatter: "{d}%",
            },
            labelLine: {
              show: false,
            },
            data: this.noRentCountList
          },
        ],
      };
      myChart.setOption(option);
    },
    mySixEcharts(){
      let that = this;
      console.log(666)
      console.log(this.newDataList)
      var myChart = this.$echarts.init(document.getElementById("six-echart"));
      //配置图表
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        color: [
          "#1584FF",
          "#FF5215",
          "#29EBB6",
          "#F6D816",
          "#8848E1",
          "#4855E1",
          "#48E178",
          "#B1E148",
          "#E148B2",
          "#CB48E1",
        ],
        legend: {
          icon: 'roundRect',
          top: '3%',
          textStyle: {
            overflow: 'truncate',
            width: 60
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          height: "65%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: this.newDateList,
          axisLabel: {
            color: '#999999'
          },
          axisLine: {
            lineStyle: {
              color: '#E2E2E2'
            }
          },
          axisTick: {
            show: false,
            lineStyle: {
              color: '#333333'
            }
          }
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#999999'
          },
          splitLine: {
            lineStyle: {
              color: '#999999',
              type: 'dashed',
              opacity: 0.2
            }
          }
        },
        series: this.newDataList
      };
      myChart.setOption(option,true);
    },
    mySevenEcharts(){
      let that = this;
      console.log(666)
      console.log(this.newDataList)
      var myChart = this.$echarts.init(document.getElementById("seven-echart"));
      //配置图表
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        color: [
          "#1584FF",
          "#FF5215",
          "#29EBB6",
          "#F6D816",
          "#8848E1",
          "#4855E1",
          "#48E178",
          "#B1E148",
          "#E148B2",
          "#CB48E1",
        ],
        legend: {
          icon: 'roundRect',
          top: '3%',
          textStyle: {
            overflow: 'truncate',
            width: 60
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          height: "65%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: this.futureDateList,
          axisLabel: {
            color: '#999999'
          },
          axisLine: {
            lineStyle: {
              color: '#E2E2E2'
            }
          },
          axisTick: {
            show: false,
            lineStyle: {
              color: '#333333'
            }
          }
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#999999'
          },
          splitLine: {
            lineStyle: {
              color: '#999999',
              type: 'dashed',
              opacity: 0.2
            }
          }
        },
        series: this.futureDataList
      };
      myChart.setOption(option,true);
    },
    myEightEcharts(){
      let that = this;
      var myChart = this.$echarts.init(document.getElementById("eight-echart"));
     //配置图表
      var option = {
        legend: {
          top: "10",
          left: 10,
          icon: "roundRect",
          show: false
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: "10%",
          left: "15%",
          height: "80%"
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.restElectricityDateList,
          axisLabel: {
            color: '#999999'
          },
          axisLine: {
            lineStyle: {
              color: '#E2E2E2'
            }
          },
          axisTick: {
            show: false,
            lineStyle: {
              color: '#333333'
            }
          }
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#999999'
          },
          splitLine: {
            lineStyle: {
              color: '#999999',
              type: 'dashed',
              opacity: 0.2
            }
          }
        },
        series: [
          {
            name: "结余电费(万元)",
            type: "line",
            stack: "Total",
            symbol: "circle",
            smooth: true,
            areaStyle: {
              opacity: 0.5,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#1584FF",
                },
                {
                  offset: 1,
                  color: "#429CFF",
                },
              ]),
            },
            itemStyle: {
              normal: {
                color: "#1584FF", //改变折线点的颜色
                lineStyle: {
                  color: "#1584FF", //改变折线颜色
                },
              },
            },
            data: this.electricityDataList,
          }
        ],
      };
      myChart.setOption(option,true);
    },
    myNineEcharts(){
      let that = this;
      console.log(666)
      console.log(this.newDataList)
      var myChart = this.$echarts.init(document.getElementById("nine-echart"));
      //配置图表
      var option = {
        legend: {
          top: "10",
          left: 10,
          icon: "roundRect",
          show: false
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: "10%",
          left: "15%",
          height: "80%"
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.restWaterDateList,
          axisLabel: {
            color: '#999999'
          },
          axisLine: {
            lineStyle: {
              color: '#E2E2E2'
            }
          },
          axisTick: {
            show: false,
            lineStyle: {
              color: '#333333'
            }
          }
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#999999'
          },
          splitLine: {
            lineStyle: {
              color: '#999999',
              type: 'dashed',
              opacity: 0.2
            }
          }
        },
        series: [
          {
            name: "结余水费",
            type: "line",
            stack: "Total",
            symbol: "circle",
            smooth: true,
            areaStyle: {
              opacity: 0.5,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#29EBB6",
                },
                {
                  offset: 1,
                  color: "#6AFF67",
                },
              ]),
            },
            itemStyle: {
              normal: {
                color: "#29EBB6", //改变折线点的颜色
                lineStyle: {
                  color: "#29EBB6", //改变折线颜色
                },
              },
            },
            data: this.waterDataList,
          }
        ],
      };
      myChart.setOption(option,true);
    },
    myTenEcharts(){
      let that = this;
      var myChart = this.$echarts.init(document.getElementById("ten-echart"));
      //配置图表
      var option = {
        tooltip: {
          trigger: "item",
        },
        color: [
          "#1584FF",
          "#FF5215",
          "#29EBB6",
          "#F6D816",
          "#8848E1",
          "#4855E1",
          "#48E178",
          "#B1E148",
          "#E148B2",
          "#CB48E1",
        ],
        title: [
          {
            text: this.allOrderPencentData.pending,
            left: this.allOrderPencentData.pending<10?"21%":this.allOrderPencentData.pending>0&&this.allOrderPencentData.pending<1000?"15%":"10%",
            top: "40%",
            textStyle: {
              fontSize: 18,
              color: "#333333",
              align: "center",
            },
          },
          {
            text: "待处理工单",
            left: "16%",
            top: "52%",
            textStyle: {
              fontSize: 10,
              color: "#999999",
              align: "right",
            },
          },
        ],
        legend: {
          type: "scroll",
          orient: "vertical",
          height: "50%",
          textStyle: {
            rich: {
              name: {
                fontSize: 10,
                color: "#666666",
                width: 45,
                padding: [0, 0, 0, 0],
              },
              num: {
                fontSize: 14,
                fontWeight: 600,
                width: 15,
                padding: [0, 0, 0, 0],
                color: "#333333",
              },
              per: {
                fontSize: 14,
                fontWeight: 600,
                padding: [0,0,0,0],
                color: '#333333'
              }
            },
          },
          formatter: function(name) {
            let tarValue;
            let total = 0;
            if (that.orderPercentList.length > 0) {
              for (let i = 0; i < that.orderPercentList.length; i++) {
                if (that.orderPercentList[i].name == name) {
                  tarValue = that.orderPercentList[i].value;
                }
                total+=parseFloat(that.orderPercentList[i].value)
              }
              let percent = ((tarValue/total)*100).toFixed(2)
              return [`{name|${name}} {num|${tarValue}}{per|${percent}%}`];
            }
          },
          icon: "circle",
          top: "42%",
          right: "3%",
        },
        series: [
          {
            name: "工单占比",
            type: "pie",
            radius: ["40%", "60%"],
            center: ["25%", "50%"],
            label: {
              show: false,
              position: "inside",
              formatter: "{d}%",
            },
            labelLine: {
              show: false,
            },
            data: this.orderPercentList
          },
        ],
      };
      myChart.setOption(option);
    },
    myElevenEcharts(){
      let that = this;
      console.log(666)
      console.log(this.orderDataList)
      console.log(this.orderDateList)
      var myChart = this.$echarts.init(document.getElementById("eleven-echart"));
      //配置图表
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        color: [
          "#1584FF",
          "#FF5215",
          "#29EBB6",
          "#F6D816",
          "#8848E1",
          "#4855E1",
          "#48E178",
          "#B1E148",
          "#E148B2",
          "#CB48E1",
        ],
        legend: {
          icon: 'roundRect',
          top: '3%'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          height: "65%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: this.orderDateList,
          axisLabel: {
            color: '#999999',
            // interval: 0
          },
          axisLine: {
            lineStyle: {
              color: '#E2E2E2'
            }
          },
          axisTick: {
            show: false,
            lineStyle: {
              color: '#333333'
            }
          }
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#999999'
          },
          splitLine: {
            lineStyle: {
              color: '#999999',
              type: 'dashed',
              opacity: 0.2
            }
          }
        },
        series: this.orderDataList
      };
      myChart.setOption(option,true);
    },
    moreData(){ // 跳转到更多数据
      this.$router.push("/cumulative-list");
    },
    backPage() {
      // 回退到app
      window.location.href = "jsToOc://back";
    },
    onClick(name, title){
      console.log(name,title)
      if(name==0){
        this.getAllData();
        this.getBillShould();
        this.getCumulativeAge();
        this.getCumulativeRank();
        this.getRevenueData();
      } else if(name==1){
        this.getRentSumData();
        this.getRentCountData();
        this.getNoRentData();
        this.getNewAreaData();
        this.getFutureAreaData();
      } else if(name==2){
        this.getEnergyData()
        this.getElectricityData()
        this.getWaterData()
      } else if(name==3){
        this.getOrderData()
        this.getOrderPencentData()
        this.getOrderTrendData()
        this.getOrderRankData()
      }
    }
  },
};
</script>
<style scoped>
.main-content {
  background-color: #f9f9f9;
}
.head-navigate {
  display: flex;
  align-items: center;
  background-color: white;
  padding: 0.3rem 0.3rem;
  border-bottom: 1px solid #f0f2f5;
}
.head-navigate span {
  font-size: 17px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #333333;
  margin: auto;
}
/* 菜单选项部分 */
.menu-content {
  padding: 0.5rem 0.4rem;
}
/* 财务部分 */
.financial-sum {
  background-color: white;
  box-shadow: 0px 2px 6px 0px #e2e4e6;
  border-radius: 8px;
}
.financial-sum > div:nth-child(1) {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f3f3f3;
  padding: 0.4rem 0.3rem;
}
.financial-sum > div:nth-child(1) span:nth-child(1) {
  font-size: 0.45rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  margin-right: auto;
  color: #333333;
}
.financial-sum > div:nth-child(1) span:nth-child(2) {
  margin-right: 0.1rem;
  color: #999999;
}
.financial-sum .one-bill {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.4rem 0.3rem;
}
.financial-sum .one-bill > div:nth-child(1) {
  width: 42%;
  display: flex;
  flex-direction: column;
}
.financial-sum .one-bill > div:nth-child(1) > span:nth-child(1) {
  font-size: 0.35rem;
  font-weight: 400;
  color: #333333;
}
.financial-sum .one-bill > div:nth-child(1) > div {
  display: flex;
  align-items: center;
  font-size: 0.7rem;
  font-weight: 600;
  color: #1584ff;
}
.financial-sum .one-bill > div:nth-child(1) > div span:nth-child(2) {
  font-size: 0.3rem;
  color: #1584ff;
  margin-left: 0.1rem;
  margin-top: 0.1rem;
}
.financial-sum .one-bill > div:nth-child(1) > span:last-child {
  font-size: 0.3rem;
  font-weight: 400;
  color: #8c9aa8;
  margin-top: 0.1rem;
}
.vertical-line {
  width: 1px;
  height: 70px;
  border: 1px solid #f3f3f3;
}
.financial-sum .one-bill > div:last-child {
  width: 45%;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-end;
  font-size: 0.7rem;
  font-weight: 600;
  color: #1584ff;
  margin-top: 0.3rem;
}
.financial-sum .one-bill > div:last-child > div {
  display: flex;
  align-items: center;
  font-size: 0.7rem;
  font-weight: 600;
  margin-top: 0.2rem;
  color: #1584ff;
}
.financial-sum .one-bill > div:last-child > div span:nth-child(2) {
  font-size: 0.3rem;
  color: #1584ff;
  margin-left: 0.1rem;
  margin-top: 0.1rem;
}
.financial-sum .one-bill > div:last-child > span:last-child {
  font-size: 0.3rem;
  font-weight: 400;
  color: #8c9aa8;
  margin-top: 0.1rem;
}
.horizontal-list{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    padding: 0 0.3rem;
}
.horizontal-line{
    height: 1px;
    border: 1px solid #F3F3F3;
}
.data-echart{
  background-color: white;
  box-shadow: 0px 2px 6px 0px #e2e4e6;
  border-radius: 8px;
  padding-bottom: 0.2rem;
  margin-top: 0.5rem;
}
.data-echart > div:nth-child(1) {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f3f3f3;
  padding: 0.4rem 0.3rem;
}
.data-echart > div:nth-child(1) .echart-title{
  display: flex;
  align-items: center;
}
.data-echart > div:nth-child(1) .echart-title>span:nth-child(1) {
  font-size: 0.45rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
}
.data-echart > div:nth-child(1) .echart-title>span:nth-child(2) {
  font-size: 0.25rem;
  color: #666666;
  margin-left: 0.1rem;
}
.data-echart >div:nth-child(1) .echart-date{
    display: flex;
    align-items: center;
    margin: auto;
}
.data-echart >div:nth-child(1) .echart-date span{
  margin-right: 0.1rem;
  color: #999999;
}
.data-echart > div:nth-child(1) .echart-select {
  margin-right: 0.1rem;
  color: #999999;
}
.data-echart>div:nth-child(2){
  width: 100%;
  height: 180px;
}
.data-echart .data-list{
  margin-top: 0.2rem;
  padding: 0 0.3rem;
}
.data-list .dataList-head{
  display: flex;
  align-items: center;
  margin-bottom: 0.2rem;
}
.data-list .dataList-body{
  display: flex;
  align-items: center;
  margin-bottom: 0.2rem;
}
.dataList-head .td{
  width: 20%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 0.3rem;
  font-weight: 400;
  color: #999999;
}
.dataList-body .td{
  width: 20%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 0.35rem;
  font-weight: 400;
  color: #333333;
}
.dataList-head .td:not(:first-child),.dataList-body .td:not(:first-child){
  text-align: center;
}
.data-rank{
  background-color: white;
  box-shadow: 0px 2px 6px 0px #e2e4e6;
  border-radius: 8px;
  padding-bottom: 0.2rem;
  margin-top: 0.5rem;
}
.data-rank > div:nth-child(1) {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f3f3f3;
  padding: 0.4rem 0.3rem;
}
.data-rank > div:nth-child(1)>div:nth-child(1) {
  display: flex;
  align-items: center;
  margin-right: auto;
}
.data-rank > div:nth-child(1)>div:nth-child(1)>span:nth-child(1) {
  font-size: 0.45rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
}
.data-rank > div:nth-child(1)>div:nth-child(1)>span:nth-child(2) {
  font-size: 0.25rem;
  color: #666666;
  margin-left: 0.1rem;
}
.data-rank > div:nth-child(1)>span:nth-child(2) {
  margin-right: 0.1rem;
  color: #999999;
}
.rank-list{
  padding: 0.3rem;
}
.rank-list .list-head{
  display: flex;
  align-items: center;
  margin-bottom: 0.1rem;
}
.rank-list .list-head .td{
  font-size: 0.35rem;
  font-weight: 400;
  color: #999999;
}
.rank-list .list-head .td:nth-child(1){
  width: 40%;
}
.rank-list .list-head .td:nth-child(2){
  width: 30%;
  margin-right: auto;
}
.rank-list .list-body{
  display: flex;
  align-items: center;
  margin-bottom: 0.1rem;
}
.rank-list .list-body .td{
  font-size: 0.40rem;
  font-weight: 400;
  color: #333333;
}
.rank-list .list-body .td:nth-child(1){
  width: 40%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.rank-list .list-body .td:nth-child(2){
  width: 30%;
  margin-right: auto;
  text-indent: 1.5em;
}
/* 租务部分 */
.rent-sum {
  background-color: white;
  box-shadow: 0px 2px 6px 0px #e2e4e6;
  border-radius: 8px;
  padding-bottom: 0.2rem;
}
.rent-sum > div:nth-child(1) {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f3f3f3;
  padding: 0.4rem 0.3rem;
}

.rent-sum > div:nth-child(1)>span:nth-child(1) {
  font-size: 0.45rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
}
.rent-sum >div:nth-child(1) div{
    display: flex;
    align-items: center;
    margin: auto;
}
.rent-sum >div:nth-child(1) div span{
  margin-right: 0.1rem;
  color: #999999;
}
.rent-sum > div:nth-child(1)>span:nth-child(3) {
  margin-right: 0.1rem;
  color: #999999;
}
.rent-area{
    width: 93%;
    display: flex;
    flex-direction: column;
    padding: 0.4rem 0rem;
    margin: 0 auto;
    border-bottom: 1px solid #F3F3F3;
}
.rent-area span:nth-child(1){
  font-size: 0.40rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 400;
  color: #333333;
}
.rent-area span:nth-child(2){
  font-size: 0.7rem;
  font-weight: 600;
  margin-top: 0.2rem;
  color: #1584ff;
}
.rent-sum .one-bill {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.4rem 0.3rem 0.1rem 0.3rem;
}
.rent-sum .one-bill > div {
  display: flex;
  flex-direction: column;
}
.rent-sum .one-bill > div:nth-child(1), .rent-sum .one-bill > div:nth-child(3){
  width: 40%;
}
.rent-sum .one-bill > div > span:nth-child(1) {
  font-size: 0.4rem;
  font-weight: 400;
  color: #333333;
  margin-right: auto;
}
.rent-sum .one-bill > div > div {
  display: flex;
  align-items: center;
  font-size: 0.7rem;
  font-weight: 600;
  margin-top: 0.2rem;
  color: #1584ff;
}
/* .rent-sum .one-bill > div > div span:nth-child(2) {
  font-size: 0.3rem;
  color: #1584ff;
  margin-left: 0.1rem;
  margin-top: 0.1rem;
} */
.rent-sum .one-bill > div > div span:nth-child(2) {
  font-size: 0.3rem;
  color: #8C9AA8;
  margin-top: 0.2rem;
  margin-left: 0.2rem;
}
.rent-sum .one-bill > div > div span:nth-child(3) {
  font-size: 0.6rem;
  color: #333333;
  font-weight: 600;
  margin-left: 0.1rem;
  margin-top: 0.1rem;
}
.rent-sum .divider-line{
  width: 100%;
  height: 10px;
  background: #F9F9F9;
}
/* 工单客户满意度部分 */
.client-list{
  padding: 0.3rem;
}
.client-list .list-head{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.1rem;
}
.client-list .list-head .td{
  font-size: 0.25rem;
  font-weight: 400;
  color: #999999;
}
.client-list .list-head .td:not(:nth-child(4)){
  width: 25% !important;
}
.client-list .list-body{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.1rem;
}
.client-list .list-body .td{
  font-size: 0.40rem;
  font-weight: 400;
  color: #333333;
  margin-right: 0.3rem;
}
.client-list .list-body .td:nth-child(1){
  width: 25%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.client-list .list-body .td:not(:nth-child(4)){
  width: 25% !important;
}
.moreData{
  border-top: 1px solid #F3F3F3;
  color: #1584FF;
  font-size: 0.4rem;
  height: 0.8rem;
  line-height: 1rem;
  text-align: center;
  font-weight: 600;
}
/* 选择公司弹框 */
.pop-title{
  display: flex;
  align-items: center;
  padding: 0.2rem 0;
}
.pop-title>span:nth-child(1){
  font-size: 0.5rem;
  font-weight: 700;
  margin-left: 0.3rem;
  margin-right: auto;
  color: #323233;
}
.pop-title>span:nth-child(2){
  font-size: 0.4rem;
  margin-right: 0.4rem;
  color: #1484FF;
}
.list-content{
  display: flex;
  flex-direction: column;
  padding: 0.3rem 0.5rem;
  line-height: 0.7rem;
}
.list-content div{
  font-size: 0.35rem;
  font-weight: 400;
  color: #323233;
}
/* 选择时间日期弹框 */
.date-title{
  display: flex;
  align-items: center;
  padding: 0.2rem 0;
  border-bottom: 1px solid #E5E5E5;
}
.date-title>span:nth-child(1){
  font-size: 0.4rem;
  margin-left: 0.4rem;
  color: #1484FF;
}
.date-title>span:nth-child(2){
  font-size: 0.5rem;
  margin: auto;
  color: #323233;
}
.date-title>span:nth-child(3){
  font-size: 0.4rem;
  margin-right: 0.4rem;
  color: #1484FF;
}
.type-select{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.6rem;
}
.type-select span{
  cursor: pointer;
  padding: 0.1rem 0.3rem;
  background: #FFFFFF;
  border: 1px solid #1484FF;
}
.type-select span:nth-child(1){
  border-right: 0;
}
.date-selector{
  margin-top: 0.6rem;
  margin-bottom: 0.3rem;
}
.date-selector>.two-div{
  display: flex;
  justify-content: center;
  align-items: center;
}
.date-selector>div /deep/.van-picker__toolbar{
  display: none !important;
}
.date-selector>.two-div /deep/.van-picker{
  width: 49% !important;
}
</style>
